import apiClient from './client';
import type { AbandonedCheckoutAnalytics } from '../types/abandonedCheckoutAnalytics';

/**
 * Client for the abandoned-checkout recovery analytics endpoint.
 *
 * One round trip returns daily abandoned/recovered series plus a summary block
 * for a single window. Computed from the local table (no external API), so it's
 * always live and the backend clamps `days` to [1, 730].
 */
export async function getAbandonedCheckoutAnalytics(
  days: number = 30
): Promise<AbandonedCheckoutAnalytics> {
  const { data } = await apiClient.get<AbandonedCheckoutAnalytics>(
    '/admin/abandoned-checkout/analytics/',
    { params: { days } }
  );
  return data;
}
